import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { RegressionScenarioStatus } from "./regression.types";

// Serenity's own result enum: SUCCESS (passed), FAILURE (assertion), ERROR/COMPROMISED
// (driver crash, timeout, uncaught exception — "broken" in this dashboard's language),
// PENDING/IGNORED (not exercised — "skipped").
export const REGRESSION_COLORS = {
  passed: "#22c55e",
  failed: "#ef4444",
  broken: "#f59e0b",
  skipped: "#94a3b8",
} as const;

export type RegressionBucket = keyof typeof REGRESSION_COLORS;

// eslint-disable-next-line react-refresh/only-export-components
export function regressionBucket(result: RegressionScenarioStatus): RegressionBucket {
  if (result === "SUCCESS") return "passed";
  if (result === "FAILURE") return "failed";
  if (result === "ERROR" || result === "COMPROMISED") return "broken";
  return "skipped"; // PENDING | IGNORED
}

// eslint-disable-next-line react-refresh/only-export-components
export const regressionStatusIcon = (result: RegressionScenarioStatus) => {
  const bucket = regressionBucket(result);
  const sx = { fontSize: 18, color: REGRESSION_COLORS[bucket] };
  if (bucket === "passed") return <CheckCircleOutlineIcon sx={sx} />;
  if (bucket === "failed") return <ErrorOutlineIcon sx={sx} />;
  if (bucket === "broken") return <ReportProblemOutlinedIcon sx={sx} />;
  return <RemoveCircleOutlineIcon sx={sx} />;
};
